{
  "pokemon": {
    "egg": 1021,
    "pikachubelle": 1022,
    "pikachulibre": 1023,
    "pikachuphd": 1024,
    "pikachupopstar": 1025,
    "pikachurockstar": 1026,
    "pikachucosplay": 1027,
    "unownexclamation": 1028,
    "unownquestion": 1029,
    "unownb": 1030,
    "unownc": 1031,
    "unownd": 1032,
    "unowne": 1033,
    "unownf": 1034,
    "unowng": 1035,
    "unownh": 1036,
    "unowni": 1037,
    "unownj": 1038,
    "unownk": 1039,
    "unownl": 1040,
    "unownm": 1041,
    "unownn": 1042,
    "unowno": 1043,
    "unownp": 1044,
    "unownq": 1045,
    "unownr": 1046,
    "unowns": 1047,
    "unownt": 1048,
    "unownu": 1049,
    "unownv": 1050,
    "unownw": 1051,
    "unownx": 1052,
    "unowny": 1053,
    "unownz": 1054,
    "castformrainy": 1055,
    "castformsnowy": 1056,
    "castformsunny": 1057,
    "deoxysattack": 1058,
    "deoxysdefense": 1059,
    "deoxysspeed": 1060,
    "burmysandy": 1061,
    "burmytrash": 1062,
    "wormadamsandy": 1063,
    "wormadamtrash": 1064,
    "cherrimsunshine": 1065,
    "shelloseast": 1066,
    "gastrodoneast": 1067,
    "rotomfan": 1068,
    "rotomfrost": 1069,
    "rotomheat": 1070,
    "rotommow": 1071,
    "rotomwash": 1072,
    "giratinaorigin": 1073,
    "shayminsky": 1074,
    "unfezantf": 1075,
    "basculinbluestriped": 1076,
    "darmanitanzen": 1077,
    "deerlingautumn": 1078,
    "deerlingsummer": 1079,
    "deerlingwinter": 1080,
    "sawsbuckautumn": 1081,
    "sawsbucksummer": 1082,
    "sawsbuckwinter": 1083,
    "frillishf": 1084,
    "jellicentf": 1085,
    "tornadustherian": 1086,
    "thundurustherian": 1087,
    "landorustherian": 1088,
    "kyuremblack": 1089,
    "kyuremwhite": 1090,
    "keldeoresolute": 1091,
    "meloettapirouette": 1092,
    "vivillonarchipelago": 1093,
    "vivilloncontinental": 1094,
    "vivillonelegant": 1095,
    "vivillonfancy": 1096,
    "vivillongarden": 1097,
    "vivillonhighplains": 1098,
    "vivillonicysnow": 1099,
    "vivillonjungle": 1100,
    "vivillonmarine": 1101,
    "vivillonmodern": 1102,
    "vivillonmonsoon": 1103,
    "vivillonocean": 1104,
    "vivillonpokeball": 1105,
    "vivillonpolar": 1106,
    "vivillonriver": 1107,
    "vivillonsandstorm": 1108,
    "vivillonsavanna": 1109,
    "vivillonsun": 1110,
    "vivillontundra": 1111,
    "pyroarf": 1112,
    "flabebeblue": 1113,
    "flabebeorange": 1114,
    "flabebewhite": 1115,
    "flabebeyellow": 1116,
    "floetteblue": 1117,
    "floetteeternal": 1118,
    "floetteorange": 1119,
    "floettewhite": 1120,
    "floetteyellow": 1121,
    "florgesblue": 1122,
    "florgesorange": 1123,
    "florgeswhite": 1124,
    "florgesyellow": 1125,
    "furfroudandy": 1126,
    "furfroudebutante": 1127,
    "furfroudiamond": 1128,
    "furfrouheart": 1129,
    "furfroukabuki": 1130,
    "furfroulareine": 1131,
    "furfroumatron": 1132,
    "furfroupharaoh": 1133,
    "furfroustar": 1134,
    "meowsticf": 1135,
    "aegislashblade": 1136,
    "xerneasneutral": 1137,
    "hoopaunbound": 1138,
    "rattataalola": 1139,
    "raticatealola": 1140,
    "raichualola": 1141,
    "sandshrewalola": 1142,
    "sandslashalola": 1143,
    "vulpixalola": 1144,
    "ninetalesalola": 1145,
    "diglettalola": 1146,
    "dugtrioalola": 1147,
    "meowthalola": 1148,
    "persianalola": 1149,
    "geodudealola": 1150,
    "graveleralola": 1151,
    "golemalola": 1152,
    "grimeralola": 1153,
    "mukalola": 1154,
    "exeggutoralola": 1155,
    "marowakalola": 1156,
    "greninjaash": 1157,
    "zygarde10": 1158,
    "zygardecomplete": 1159,
    "oricoriopompom": 1160,
    "oricoriopau": 1161,
    "oricoriosensu": 1162,
    "lycanrocmidnight": 1163,
    "wishiwashischool": 1164,
    "minior": 1165,
    "miniormeteor": 1165,
    "miniororange": 1166,
    "minioryellow": 1167,
    "miniorgreen": 1168,
    "miniorblue": 1169,
    "miniorindigo": 1170,
    "miniorviolet": 1171,
    "magearnaoriginal": 1172,
    "pikachuoriginal": 1173,
    "pikachuhoenn": 1174,
    "pikachusinnoh": 1175,
    "pikachuunova": 1176,
    "pikachukalos": 1177,
    "pikachualola": 1178,
    "pikachupartner": 1179,
    "lycanrocdusk": 1180,
    "necrozmaduskmane": 1181,
    "necrozmadawnwings": 1182,
    "necrozmaultra": 1183,
    "pikachustarter": 1184,
    "eeveestarter": 1185,
    "meowthgalar": 1186,
    "ponytagalar": 1187,
    "rapidashgalar": 1188,
    "farfetchdgalar": 1189,
    "weezinggalar": 1190,
    "mrmimegalar": 1191,
    "corsolagalar": 1192,
    "zigzagoongalar": 1193,
    "linoonegalar": 1194,
    "darumakagalar": 1195,
    "darmanitangalar": 1196,
    "darmanitangalarzen": 1197,
    "yamaskgalar": 1198,
    "stunfiskgalar": 1199,
    "cramorantgulping": 1200,
    "cramorantgorging": 1201,
    "toxtricitylowkey": 1202,
    "alcremierubycream": 1203,
    "alcremiematchacream": 1204,
    "alcremiemintcream": 1205,
    "alcremielemoncream": 1206,
    "alcremiesaltedcream": 1207,
    "alcremierubyswirl": 1208,
    "alcremiecaramelswirl": 1209,
    "alcremierainbowswirl": 1210,
    "eiscuenoice": 1211,
    "indeedeef": 1212,
    "morpekohangry": 1213,
    "zaciancrowned": 1214,
    "zamazentacrowned": 1215,
    "slowpokegalar": 1216,
    "slowbrogalar": 1217,
    "zarudedada": 1218,
    "pikachuworld": 1219,
    "articunogalar": 1220,
    "zapdosgalar": 1221,
    "moltresgalar": 1222,
    "slowkinggalar": 1223,
    "calyrexice": 1224,
    "calyrexshadow": 1225,
    "growlithehisui": 1226,
    "arcaninehisui": 1227,
    "voltorbhisui": 1228,
    "electrodehisui": 1229,
    "typhlosionhisui": 1230,
    "qwilfishhisui": 1231,
    "sneaselhisui": 1232,
    "samurotthisui": 1233,
    "lilliganthisui": 1234,
    "zoruahisui": 1235,
    "zoroarkhisui": 1236,
    "braviaryhisui": 1237,
    "sliggoohisui": 1238,
    "goodrahisui": 1239,
    "avalugghisui": 1240,
    "decidueyehisui": 1241,
    "basculegionf": 1242,
    "enamorustherian": 1243,
    "taurospaldea": 1244,
    "taurospaldeafire": 1245,
    "taurospaldeawater": 1246,
    "taurospaldeacombat": 1244,
    "taurospaldeablaze": 1245,
    "taurospaldeaaqua": 1246,
    "wooperpaldea": 1247,
    "oinkolognef": 1248,
    "palafinhero": 1249,
    "mausholdfour": 1250,
    "tatsugiridroopy": 1251,
    "tatsugiristretchy": 1252,
    "squawkabillyblue": 1253,
    "squawkabillyyellow": 1254,
    "squawkabillywhite": 1255,
    "gimmighoulroaming": 1256,
    "dialgaorigin": 1257,
    "palkiaorigin": 1258,
    "basculinwhitestriped": 1259,
    "ursalunabloodmoon": 1260,
    "ogerponwellspring": 1261,
    "ogerponhearthflame": 1262,
    "ogerponcornerstone": 1263,
    "greninjabond": 658,
    "gumshoostotem": 735,
    "raticatealolatotem": 1140,
    "marowakalolatotem": 1156,
    "araquanidtotem": 752,
    "lurantistotem": 754,
    "salazzletotem": 758,
    "vikavolttotem": 738,
    "togedemarutotem": 777,
    "mimikyutotem": 778,
    "mimikyubustedtotem": 778,
    "ribombeetotem": 743,
    "kommoototem": 784,
    "sinisteaantique": 854,
    "polteageistantique": 855,
    "poltchageistartisan": 1012,
    "sinistchamasterpiece": 1013,
    "ogerpontealtera": 1017,
    "ogerponwellspringtera": 1261,
    "ogerponhearthflametera": 1262,
    "ogerponcornerstonetera": 1263,
    "venusaurmega": 1272,
    "charizardmegax": 1273,
    "charizardmegay": 1274,
    "blastoisemega": 1275,
    "beedrillmega": 1276,
    "pidgeotmega": 1277,
    "alakazammega": 1278,
    "slowbromega": 1279,
    "gengarmega": 1280,
    "kangaskhanmega": 1281,
    "pinsirmega": 1282,
    "gyaradosmega": 1283,
    "aerodactylmega": 1284,
    "mewtwomegax": 1285,
    "mewtwomegay": 1286,
    "ampharosmega": 1287,
    "steelixmega": 1288,
    "scizormega": 1289,
    "heracrossmega": 1290,
    "houndoommega": 1291,
    "tyranitarmega": 1292,
    "sceptilemega": 1293,
    "blazikenmega": 1294,
    "swampertmega": 1295,
    "gardevoirmega": 1296,
    "sableyemega": 1297,
    "mawilemega": 1298,
    "aggronmega": 1299,
    "medichammega": 1300,
    "manectricmega": 1301,
    "sharpedomega": 1302,
    "cameruptmega": 1303,
    "altariamega": 1304,
    "banettemega": 1305,
    "absolmega": 1306,
    "glaliemega": 1307,
    "salamencemega": 1308,
    "metagrossmega": 1309,
    "latiasmega": 1310,
    "latiosmega": 1311,
    "kyogreprimal": 1312,
    "groudonprimal": 1313,
    "rayquazamega": 1314,
    "lopunnymega": 1315,
    "garchompmega": 1316,
    "lucariomega": 1317,
    "abomasnowmega": 1318,
    "gallademega": 1319,
    "audinomega": 1320,
    "dianciemega": 1321,
    "charizardgmax": 1322,
    "butterfreegmax": 1323,
    "pikachugmax": 1324,
    "meowthgmax": 1325,
    "machampgmax": 1326,
    "gengargmax": 1327,
    "kinglergmax": 1328,
    "laprasgmax": 1329,
    "eeveegmax": 1330,
    "snorlaxgmax": 1331,
    "garbodorgmax": 1332,
    "melmetalgmax": 1333,
    "corviknightgmax": 1334,
    "orbeetlegmax": 1335,
    "drednawgmax": 1336,
    "coalossalgmax": 1337,
    "flapplegmax": 1338,
    "appletungmax": 1339,
    "sandacondagmax": 1340,
    "toxtricitygmax": 1341,
    "toxtricitylowkeygmax": 1341,
    "centiskorchgmax": 1342,
    "hatterenegmax": 1343,
    "grimmsnarlgmax": 1344,
    "alcremiegmax": 1345,
    "copperajahgmax": 1346,
    "duraludongmax": 1347,
    "eternatuseternamax": 1348,
    "venusaurgmax": 1349,
    "blastoisegmax": 1350,
    "rillaboomgmax": 1351,
    "cinderacegmax": 1352,
    "inteleongmax": 1353,
    "urshifugmax": 1354,
    "urshifurapidstrikegmax": 1355
  },
  "items": {
    "megastonei": 618,
    "megastoneii": 619,
    "abilityshield": 746,
    "abomasite": 575,
    "absolite": 576,
    "absorbbulb": 2,
    "adamantcrystal": 741,
    "adamantorb": 4,
    "adrenalineorb": 660,
    "aerodactylite": 577,
    "aggronite": 578,
    "aguavberry": 5,
    "airballoon": 6,
    "alakazite": 579,
    "aloraichiumz": 655,
    "altarianite": 615,
    "ampharosite": 580,
    "apicotberry": 10,
    "armorfossil": 12,
    "aspearberry": 13,
    "assaultvest": 581,
    "audinite": 617,
    "auspiciousarmor": 753,
    "babiriberry": 17,
    "banettite": 582,
    "beastball": 661,
    "beedrillite": 628,
    "belueberry": 21,
    "berryjuice": 22,
    "berrysweet": 706,
    "bignugget": 27,
    "bigroot": 29,
    "bindingband": 31,
    "blackbelt": 32,
    "blackglasses": 35,
    "blacksludge": 34,
    "blastoisinite": 583,
    "blazikenite": 584,
    "blueorb": 41,
    "blukberry": 44,
    "blunderpolicy": 716,
    "boosterenergy": 745,
    "bottlecap": 696,
    "brightpowder": 51,
    "buggem": 53,
    "bugmemory": 673,
    "buginiumz": 642,
    "burndrive": 54,
    "cameruptite": 625,
    "cellbattery": 60,
    "charcoal": 61,
    "charizarditex": 585,
    "charizarditey": 586,
    "chartiberry": 62,
    "cheriberry": 63,
    "cherishball": 64,
    "chestoberry": 65,
    "chilanberry": 66,
    "chilldrive": 67,
    "chippedpot": 720,
    "choiceband": 68,
    "choicescarf": 69,
    "choicespecs": 70,
    "chopleberry": 71,
    "clawfossil": 72,
    "clearamulet": 747,
    "cloversweet": 707,
    "cobaberry": 76,
    "colburberry": 78,
    "cornerstonemask": 758,
    "cornnberry": 81,
    "coverfossil": 85,
    "covertcloak": 750,
    "crackedpot": 719,
    "custapberry": 86,
    "damprock": 88,
    "darkgem": 89,
    "darkmemory": 683,
    "darkiniumz": 646,
    "dawnstone": 92,
    "decidiumz": 650,
    "deepseascale": 93,
    "deepseatooth": 94,
    "destinyknot": 95,
    "diancite": 624,
    "diveball": 101,
    "domefossil": 102,
    "dousedrive": 103,
    "dracoplate": 105,
    "dragonfang": 106,
    "dragongem": 107,
    "dragonmemory": 682,
    "dragonscale": 108,
    "dragoniumz": 645,
    "dreadplate": 110,
    "dreamball": 111,
    "dubiousdisc": 113,
    "durinberry": 114,
    "duskball": 115,
    "duskstone": 116,
    "earthplate": 117,
    "eeviumz": 657,
    "ejectbutton": 118,
    "ejectpack": 714,
    "electirizer": 119,
    "electricgem": 120,
    "electricmemory": 679,
    "electricseed": 664,
    "electriumz": 634,
    "enigmaberry": 124,
    "eviolite": 130,
    "expertbelt": 132,
    "fairiumz": 648,
    "fairyfeather": 754,
    "fairygem": 611,
    "fairymemory": 684,
    "fastball": 137,
    "fightinggem": 139,
    "fightingmemory": 668,
    "fightiniumz": 637,
    "figyberry": 140,
    "firegem": 141,
    "firememory": 676,
    "firestone": 142,
    "firiumz": 632,
    "fistplate": 143,
    "flameorb": 145,
    "flameplate": 146,
    "floatstone": 147,
    "flowersweet": 708,
    "flyinggem": 149,
    "flyingmemory": 669,
    "flyiniumz": 640,
    "focusband": 150,
    "focussash": 151,
    "fossilizedbird": 700,
    "fossilizeddino": 703,
    "fossilizeddrake": 702,
    "fossilizedfish": 701,
    "friendball": 153,
    "fullincense": 155,
    "galaricacuff": 739,
    "galaricawreath": 740,
    "galladite": 616,
    "ganlonberry": 158,
    "garchompite": 589,
    "gardevoirite": 587,
    "gengarite": 588,
    "ghostgem": 161,
    "ghostmemory": 674,
    "ghostiumz": 644,
    "glalitite": 623,
    "goldbottlecap": 697,
    "grassgem": 172,
    "grassmemory": 678,
    "grassiumz": 635,
    "grassyseed": 667,
    "greatball": 174,
    "grepaberry": 178,
    "gripclaw": 179,
    "griseouscore": 743,
    "griseousorb": 180,
    "groundgem": 182,
    "groundmemory": 671,
    "groundiumz": 639,
    "gyaradosite": 589,
    "habanberry": 185,
    "hardstone": 187,
    "healball": 188,
    "hearthflamemask": 760,
    "heatrock": 193,
    "heavyball": 194,
    "heavydutyboots": 715,
    "helixfossil": 195,
    "heracronite": 590,
    "hondewberry": 213,
    "houndoominite": 591,
    "iapapaberry": 217,
    "icegem": 218,
    "icememory": 681,
    "icestone": 693,
    "icicleplate": 220,
    "iciumz": 636,
    "icyrock": 221,
    "inciniumz": 651,
    "insectplate": 223,
    "ironball": 224,
    "ironplate": 225,
    "jabocaberry": 230,
    "jawfossil": 694,
    "kasibberry": 233,
    "kebiaberry": 234,
    "keeberry": 593,
    "kelpsyberry": 235,
    "kangaskhanite": 592,
    "kingsrock": 236,
    "kommoniumz": 690,
    "laggingtail": 237,
    "lansatberry": 238,
    "latiasite": 629,
    "latiosite": 630,
    "laxincense": 240,
    "leafstone": 241,
    "leek": 475,
    "leftovers": 242,
    "leppaberry": 244,
    "levelball": 246,
    "liechiberry": 248,
    "lifeorb": 249,
    "lightball": 251,
    "lightclay": 252,
    "loadeddice": 751,
    "lopunnite": 626,
    "loveball": 258,
    "lovesweet": 705,
    "lucarionite": 594,
    "luckypunch": 261,
    "lumberry": 262,
    "luminousmoss": 595,
    "lunaliumz": 686,
    "lureball": 264,
    "lustrousglobe": 742,
    "lustrousorb": 265,
    "luxuryball": 266,
    "lycaniumz": 689,
    "machobrace": 269,
    "magmarizer": 272,
    "magnet": 273,
    "magoberry": 274,
    "magostberry": 275,
    "mail": 403,
    "maliciousarmor": 744,
    "manectite": 596,
    "marangaberry": 597,
    "marshadiumz": 654,
    "masterball": 276,
    "masterpieceteacup": 757,
    "mawilite": 598,
    "meadowplate": 282,
    "medichamite": 599,
    "mentalherb": 285,
    "metagrossite": 618,
    "metalcoat": 286,
    "metalpowder": 287,
    "metronome": 289,
    "mewniumz": 658,
    "mewtwonitex": 600,
    "mewtwonitey": 601,
    "micleberry": 290,
    "mimikiumz": 688,
    "mindplate": 291,
    "miracleseed": 292,
    "mirrorherb": 748,
    "mistyseed": 666,
    "moonball": 294,
    "moonstone": 295,
    "muscleband": 297,
    "mysticwater": 300,
    "nanabberry": 302,
    "nestball": 303,
    "netball": 304,
    "nevermeltice": 305,
    "nomelberry": 306,
    "normalgem": 307,
    "normaliumz": 631,
    "occaberry": 311,
    "oddincense": 312,
    "oldamber": 314,
    "oranberry": 319,
    "ovalstone": 321,
    "pamtreberry": 323,
    "parkball": 325,
    "passhoberry": 329,
    "payapaberry": 330,
    "pechaberry": 333,
    "persimberry": 334,
    "petayaberry": 335,
    "pidgeotite": 622,
    "pikaniumz": 649,
    "pikashuniumz": 659,
    "pinapberry": 337,
    "pinsirite": 602,
    "pixieplate": 610,
    "plumefossil": 339,
    "poisonbarb": 343,
    "poisongem": 344,
    "poisonmemory": 670,
    "poisoniumz": 638,
    "pokeball": 345,
    "pomegberry": 351,
    "poweranklet": 354,
    "powerband": 355,
    "powerbelt": 356,
    "powerbracer": 357,
    "powerherb": 358,
    "powerlens": 359,
    "powerweight": 360,
    "premierball": 363,
    "primariumz": 652,
    "prismscale": 365,
    "protectivepads": 663,
    "protector": 367,
    "psychicgem": 369,
    "psychicmemory": 680,
    "psychicseed": 665,
    "psychiumz": 641,
    "punchingglove": 749,
    "qualotberry": 371,
    "quickball": 372,
    "quickclaw": 373,
    "quickpowder": 374,
    "rabutaberry": 375,
    "rarebone": 379,
    "rawstberry": 381,
    "razorclaw": 382,
    "razorfang": 383,
    "razzberry": 384,
    "reapercloth": 385,
    "redcard": 387,
    "redorb": 390,
    "repeatball": 401,
    "ribbonsweet": 710,
    "rindoberry": 409,
    "ringtarget": 410,
    "rockgem": 415,
    "rockincense": 416,
    "rockmemory": 672,
    "rockiumz": 643,
    "rockyhelmet": 417,
    "roomservice": 717,
    "rootfossil": 418,
    "roseincense": 419,
    "roseliberry": 603,
    "rowapberry": 420,
    "rustedshield": 699,
    "rustedsword": 698,
    "sablenite": 614,
    "sachet": 691,
    "safariball": 425,
    "safetygoggles": 604,
    "sailfossil": 695,
    "salacberry": 426,
    "salamencite": 627,
    "sceptilite": 613,
    "scizorite": 605,
    "scopelens": 429,
    "seaincense": 430,
    "sharpbeak": 436,
    "sharpedonite": 619,
    "shedshell": 437,
    "shellbell": 438,
    "shinystone": 439,
    "shockdrive": 442,
    "shucaberry": 443,
    "silkscarf": 444,
    "silverpowder": 447,
    "sitrusberry": 448,
    "skullfossil": 449,
    "skyplate": 450,
    "slowbronite": 620,
    "smoothrock": 453,
    "snorliumz": 656,
    "snowball": 606,
    "softsand": 456,
    "solganiumz": 685,
    "souldew": 459,
    "spelltag": 461,
    "spelonberry": 462,
    "splashplate": 463,
    "spookyplate": 464,
    "sportball": 465,
    "starfberry": 472,
    "starsweet": 709,
    "steelixite": 621,
    "steelgem": 473,
    "steelmemory": 675,
    "steeliumz": 647,
    "stick": 475,
    "stickybarb": 476,
    "stoneplate": 477,
    "strangeball": 308,
    "strawberrysweet": 704,
    "sunstone": 480,
    "swampertite": 612,
    "sweetapple": 711,
    "syrupyapple": 755,
    "tamatoberry": 486,
    "tangaberry": 487,
    "tapuniumz": 653,
    "tartapple": 712,
    "terrainextender": 662,
    "thickclub": 491,
    "throatspray": 713,
    "thunderstone": 492,
    "timerball": 494,
    "toxicorb": 515,
    "toxicplate": 516,
    "tr00": 721,
    "tr01": 721,
    "tr02": 730,
    "tr03": 731,
    "tr04": 731,
    "tr05": 735,
    "tr06": 735,
    "tr07": 722,
    "tr08": 733,
    "tr09": 733,
    "tr10": 725,
    "tr11": 734,
    "tr12": 734,
    "tr13": 721,
    "tr14": 721,
    "tr15": 730,
    "tr16": 731,
    "tr17": 734,
    "tr18": 727,
    "tr19": 721,
    "tr20": 721,
    "tr21": 722,
    "tr22": 724,
    "tr23": 725,
    "tr24": 736,
    "tr25": 734,
    "tr26": 721,
    "tr27": 721,
    "tr28": 727,
    "tr29": 721,
    "tr30": 721,
    "tr31": 729,
    "tr32": 737,
    "tr33": 728,
    "tr34": 734,
    "tr35": 721,
    "tr36": 730,
    "tr37": 737,
    "tr38": 734,
    "tr39": 722,
    "tr40": 734,
    "tr41": 730,
    "tr42": 721,
    "tr43": 730,
    "tr44": 734,
    "tr45": 731,
    "tr46": 729,
    "tr47": 736,
    "tr48": 722,
    "tr49": 734,
    "tr50": 732,
    "tr51": 736,
    "tr52": 729,
    "tr53": 722,
    "tr54": 724,
    "tr55": 730,
    "tr56": 722,
    "tr57": 724,
    "tr58": 737,
    "tr59": 732,
    "tr60": 727,
    "tr61": 727,
    "tr62": 736,
    "tr63": 726,
    "tr64": 722,
    "tr65": 732,
    "tr66": 723,
    "tr67": 725,
    "tr68": 737,
    "tr69": 734,
    "tr70": 729,
    "tr71": 732,
    "tr72": 732,
    "tr73": 724,
    "tr74": 729,
    "tr75": 726,
    "tr76": 726,
    "tr77": 732,
    "tr78": 724,
    "tr79": 729,
    "tr80": 733,
    "tr81": 737,
    "tr82": 734,
    "tr83": 734,
    "tr84": 731,
    "tr85": 721,
    "tr86": 733,
    "tr87": 725,
    "tr88": 730,
    "tr89": 723,
    "tr90": 738,
    "tr91": 724,
    "tr92": 738,
    "tr93": 737,
    "tr94": 725,
    "tr95": 737,
    "tr96": 727,
    "tr97": 734,
    "tr98": 731,
    "tr99": 722,
    "twistedspoon": 520,
    "tyranitarite": 607,
    "ultraball": 521,
    "ultranecroziumz": 687,
    "unremarkableteacup": 756,
    "upgrade": 523,
    "utilityumbrella": 718,
    "venusaurite": 608,
    "wacanberry": 526,
    "watergem": 528,
    "watermemory": 677,
    "waterstone": 529,
    "wateriumz": 633,
    "watmelberry": 530,
    "waveincense": 531,
    "weaknesspolicy": 609,
    "wellspringmask": 759,
    "wepearberry": 533,
    "whippeddream": 692,
    "whiteherb": 535,
    "widelens": 537,
    "wikiberry": 538,
    "wiseglasses": 539,
    "yacheberry": 567,
    "zapplate": 572,
    "zoomlens": 574,
    "berserkgene": 388,
    "berry": 319,
    "bitterberry": 334,
    "burntberry": 13,
    "goldberry": 448,
    "iceberry": 381,
    "mintberry": 65,
    "miracleberry": 262,
    "mysteryberry": 244,
    "pinkbow": 444,
    "polkadotbow": 444,
    "przcureberry": 63,
    "psncureberry": 333,
    "crucibellite": 577,
    "vilevial": 752
  }
}